import clsx from 'clsx';
import { Base } from '../../Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "Help-root_1F4jj",
  "default": "Help-default_3OayV",
  "checkbox": "Help-checkbox_1h27Q",
  "radio": "Help-radio_CUuZD",
  "switch": "Help-switch_1SXFm"
};
function Help({
  tagName = 'p',
  variant = 'default',
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Base, {
    tagName: tagName,
    color: "light",
    marginTop: "none",
    marginBottom: "none",
    className: clsx(styles.root, styles[variant], className),
    ...extraProps
  });
}
export default Help;